// extracted by mini-css-extract-plugin
module.exports =  {"control":"control--dpNIQ"};